module.exports = __webpack_public_path__ + "static/media/managAssistantIcon.b0a3a0ad.svg";